/*
 * Copyright (c) 2019 Pegasystems Inc.
 * All rights reserved.
 */
import { from } from 'rxjs';
import { map } from 'rxjs/operators';

import { resolveRestApi } from '../../router/app-router';
import { fetch } from '../../service_broker/fetch';
import { logAndCatchError } from '../../utils/rxjs-utils';
import { processHeaders } from '../../store/state/epics/util';

import type { ActionPayload } from './types';

const DXAPI_ERROR = 'Error occurred during ajax call at getDataObjectView Epic';

const executeOpenDataObjectFlowAction = (actionInPayload: ActionPayload) => {
  const { lookupDatapage, context, headers, actionID, dataViewParameters } = actionInPayload;

  const requestParams = {
    data_view_ID: lookupDatapage,
    action_ID: actionID
  };

  const { restApi, reqType } = resolveRestApi('openDataObjectAction', requestParams);

  return from(
    fetch(
      restApi,
      {
        method: reqType,
        headers,
        body: {
          dataViewParameters
        }
      },
      context
    )
  ).pipe(
    map((response: any) => {
      return {
        response: response.data,
        headers: processHeaders(response.headers),
        actionInPayload
      };
    }),
    logAndCatchError(DXAPI_ERROR, context)
  );
};

export default executeOpenDataObjectFlowAction;
